import React from "react";

function CollectionEmptyState() {
  return (
    <svg
      style={{ maxWidth: 1120 }}
      data-testid="collection-empty-state"
      viewBox="0 0 944 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.7"
        x="0.5"
        y="0.5"
        width="463"
        height="215"
        rx="7.5"
        fill="white"
        stroke="#F0F0F0"
      />
      <rect
        width="42"
        height="200"
        transform="matrix(-1 0 0 1 428 16)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="177"
        transform="matrix(-1 0 0 1 378 39)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="127.941"
        transform="matrix(-1 0 0 1 328 88.0588)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="83.8235"
        transform="matrix(-1 0 0 1 278 132.176)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="41.1765"
        transform="matrix(-1 0 0 1 228 174.824)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="147.059"
        transform="matrix(-1 0 0 1 178 68.9412)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="110"
        transform="matrix(-1 0 0 1 128 106)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        width="42"
        height="84"
        transform="matrix(-1 0 0 1 78 132)"
        fill="#EDF2F5"
        fillOpacity="0.5"
      />
      <rect
        opacity="0.7"
        x="483.049"
        y="0.5"
        width="460.451"
        height="215"
        rx="7.5"
        fill="white"
        stroke="#F0F0F0"
      />
      <path
        opacity="0.5"
        d="M550.992 198.14L515.496 184.744L480 192.48V208C480 212.418 483.582 216 488 216H933.451C937.869 216 941.451 212.418 941.451 208V24L905.954 35.1628L870.458 59.7209L834.962 44.093L799.466 77.5814L763.97 59.7209L728.473 86.5116L692.977 104.372L657.481 77.5814L621.985 176.93L586.489 150.14L550.992 198.14Z"
        fill="#EDF2F5"
      />
      <path
        d="M481.275 193.44L515.496 184.744L550.992 198.14L586.488 150.14L621.985 176.93L657.481 77.5814L692.977 104.372L728.473 86.5116L763.969 59.7209L799.466 77.5814L834.962 44.093L870.458 59.7209L905.954 35.1628L941.45 24"
        stroke="#EDF2F5"
        strokeWidth="2"
      />
      <rect
        opacity="0.7"
        x="0.5"
        y="232.5"
        width="463"
        height="127"
        rx="7.5"
        fill="white"
        stroke="#F0F0F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216 281.714C216 279.505 217.791 277.714 220 277.714H244H245C246.657 277.714 248 279.057 248 280.714V281.714V285.714V305.714C248 307.923 246.209 309.714 244 309.714H220C218.136 309.714 216.57 308.44 216.126 306.714H216V305.714V285.714V281.714ZM244 285.714V305.714H220V285.714H244ZM233.455 296.623H223.273V300.987H233.455V296.623ZM223.273 289.805H240.727V294.169H223.273V289.805ZM240.727 296.623H236.364V300.987H240.727V296.623Z"
        fill="#EDF2F5"
      />
      <rect
        opacity="0.7"
        x="480.5"
        y="232.5"
        width="463"
        height="127"
        rx="7.5"
        fill="white"
        stroke="#F0F0F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M696 281.714C696 279.505 697.791 277.714 700 277.714H724H725C726.657 277.714 728 279.057 728 280.714V281.714V285.714V305.714C728 307.923 726.209 309.714 724 309.714H700C698.136 309.714 696.57 308.44 696.126 306.714H696V305.714V285.714V281.714ZM724 285.714V305.714H700V285.714H724ZM713.455 296.623H703.273V300.987H713.455V296.623ZM703.273 289.805H720.727V294.169H703.273V289.805ZM720.727 296.623H716.364V300.987H720.727V296.623Z"
        fill="#EDF2F5"
      />
      <rect y="440" width="258.683" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="440"
        width="113.898"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="440"
        width="103.28"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="472" width="402.503" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="472"
        width="99.4192"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="472"
        width="113.898"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="504" width="207.526" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="504"
        width="130.307"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="504"
        width="89.7669"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="536" width="354.241" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="536"
        width="113.898"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="536"
        width="103.28"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="568" width="370.65" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="568"
        width="106.176"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="568"
        width="89.7669"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="600" width="233.587" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="600"
        width="138.029"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="600"
        width="103.28"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="632" width="284.744" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="632"
        width="106.176"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="632"
        width="103.28"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="664" width="258.683" height="8" rx="4" fill="#EDF2F5" />
      <rect
        x="630.708"
        y="664"
        width="113.898"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect
        x="830.102"
        y="664"
        width="113.898"
        height="8"
        rx="4"
        fill="#EDF2F5"
      />
      <rect y="408" width="50.1239" height="8" rx="4" fill="#EDF2F5" />
      <rect x="631" y="408" width="73.515" height="8" rx="4" fill="#EDF2F5" />
      <rect x="830" y="408" width="60.9841" height="8" rx="4" fill="#EDF2F5" />
    </svg>
  );
}

export default CollectionEmptyState;
